// @flow

import {connect} from 'react-redux';
import {removeNotification} from '../../actions/notification';
import Notifications from '../../components/Notifications/Notifications';

export default connect(
  ({notifications}) => ({notifications}),
  dispatch => ({
    removeNotification: id =>
      dispatch(removeNotification(id)),
  })
)(Notifications);



// WEBPACK FOOTER //
// ./src/containers/NotificationContainer/NotificationContainer.js